import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import 'regenerator-runtime'
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
import OfferModal from './offerModal'
import Filter from './filter'
import { CareerContextProvider } from './offersContext'

TimeAgo.addDefaultLocale(en)

export default function App({ defaultOffers = null }) {
  const [offers, setOffers] = useState(defaultOffers)
  const resetBtnRef = useRef()

  const reset = () => {
    resetBtnRef.current.resetFilters()
  }

  if (!offers) return null
  return (
    <CareerContextProvider offers={offers} updateOffers={setOffers}>
      <div className='grid-container vacancies__form'>
        <div className='grid-x grid-margin-x'>
          <div className='cell large-6 large-offset-1 medium-10 medium-offset-1 small-12 small-order-2 large-order-1'>
            <div className='title slide-up title--small title--big-lh title--letter-spacing title--beige vacancies__inner-title'>
              <div>
                <h3>Jobs</h3>
              </div>
            </div>
            <ul className='vacancies__list'>
              {offers.map(offer => (
                <li
                  className='vacancies__item animate'
                  data-element-animate
                  key={offer.id}
                >
                  <div className='text text--no-space text--capitalize mb-8'>
                    <p>{offer.title}</p>
                  </div>
                  <ul className='flex-container flex-dir-column medium-flex-dir-row vacancies__details-list mb-24'>
                    {/* <li className='flex-container align-middle vacancies__company vacancies__details-item'>
                      <p>{offer.company_name}</p>
                    </li> */}
                    <li className='flex-container align-middle vacancies__city vacancies__details-item'>
                      <span
                        className='vacancies__icon'
                        style={{
                          backgroundImage:
                            'url(https://globaljet.aero/themes/custom/globaljet/images/marker.svg)',
                        }}
                      ></span>
                      <p>{offer.city}</p>
                    </li>
                    <li className='flex-container align-middle vacancies__schedule vacancies__details-item'>
                      <span
                        className='vacancies__icon'
                        style={{
                          backgroundImage:
                            'url(https://globaljet.aero/themes/custom/globaljet/images/time.svg)',
                        }}
                      ></span>
                      <p>
                        {offer.employment_type_code &&
                          offer.employment_type_code}
                      </p>
                    </li>
                    {/* <li className='flex-container align-middle vacancies__date vacancies__details-item'>
                      <span
                        className='vacancies__icon'
                        style={{
                          backgroundImage:
                            'url(https://globaljet.aero/themes/custom/globaljet/images/calendar.svg)',
                        }}
                      ></span>
                      <p>{timeAgo.format(new Date(offer.created_at))} </p>
                    </li> */}
                  </ul>
                  <OfferModal offer={offer} />
                </li>
              ))}
            </ul>

            {offers.length === 0 && (
              <div className='text text-center'>
                <p>No results found</p>
                <button onClick={reset} className='reset_btn'>
                  Reset
                </button>
              </div>
            )}
          </div>
          <div className='cell large-4 large-offset-0 medium-5 medium-10 medium-offset-1 small-12 small-order-1 vacancies__search-container'>
            <Filter ref={resetBtnRef} />
          </div>
        </div>
      </div>
    </CareerContextProvider>
  )
}

App.propTypes = {
  defaultOffers: PropTypes.array
}

